import Honeybadger from '@honeybadger-io/js';

import { requestApi } from 'api/Api';

export const getCustomFormResponse = async ({
  appointmentId,
  clinicalNoteId,
  patientId,
  practiceId = null,
  type = [
    'allergies',
    'medicalHistory',
    'vaccines',
    'conditions',
    'familyHistory',
    'socialHistory',
    'surgicalHistory',
    'weightLossAdministration'
  ],
  fromMyPortal = false,
  queryClient
}) => {
  const fetchFn = async () => {
    const customResponsesRes = await requestApi({
      url: '/api/custom_form_response/read',
      params: {
        practiceId,
        patientId,
        allVersions: true,
        type,
        fromMyPortal,
        appointmentId,
        clinicalNoteId
      }
    });

    return customResponsesRes?.response;
  };

  try {
    if (queryClient) {
      const typeKey = [...type].sort().join(',');
      return await queryClient.fetchQuery(
        ['customFormResponse', patientId, appointmentId, typeKey, practiceId ?? null, fromMyPortal],
        fetchFn,
        { staleTime: 1000 * 60 * 5 }
      );
    }

    return await fetchFn();
  } catch (error) {
    console.log({ error });
  }
};

export const getPatientHistory = async ({
  appointmentId,
  clinicalNoteId,
  patientId,
  type,
  setPatientHistoryLoading = () => {},
  setOverviewData = () => {}
}) => {
  try {
    setPatientHistoryLoading(true);

    const customFormResponse = await getCustomFormResponse({
      patientId,
      type,
      appointmentId,
      clinicalNoteId
    });

    setOverviewData((prevState) => ({
      ...prevState,
      ...customFormResponse
    }));
  } catch (error) {
    console.error(error);
    Honeybadger.notify(
      `Clinical note get custom responses - patientId: ${patientId}, error: ${error}`
    );
  } finally {
    setPatientHistoryLoading(false);
  }
};
